//libs
import React, { memo } from 'react';

// global components
import RouteChunkRenderer from 'shared/components/RouteChunkRenderer';
import ChunkFallback from 'shared/components/ChunkFallback';

// components
import CMSPage from 'shared/layouts/CMSPage';

interface CMSProps {
  pageId: string;
}

function CMS({ pageId }: Partial<CMSProps>) {
  return (
    <RouteChunkRenderer
      mobileComponent={<CMSPage pageId={pageId} isMobile fallback={<ChunkFallback />} />}
      desktopComponent={<CMSPage pageId={pageId} fallback={<ChunkFallback />} />}
    />
  );
}

export default memo(CMS);
